import { ADD_MEDICATIONS, FETCHING_MEDICATIONS, FETCHED_MEDICATIONS, CLEAR_ALL } from '../constants';

interface MedicationsState {
  list: Record<string, any[]>;
  fetching: boolean;
  fetched: Record<string, number>;
}

const initialState: MedicationsState = {
  list: {},
  fetching: false,
  fetched: {},
};

export default function medicationsReducer(
  state = initialState,
  { type, payload }: { type: string; payload?: any },
): MedicationsState {
  switch (type) {
    case CLEAR_ALL:
      return initialState;
    case ADD_MEDICATIONS:
      return {
        ...state,
        list: { ...state.list, [String(payload.project_id)]: payload.list },
      };
    case FETCHING_MEDICATIONS:
      return { ...state, fetching: payload };
    case FETCHED_MEDICATIONS:
      return { ...state, fetched: { ...state.fetched, [String(payload.project_id)]: Date.now() } };
    default:
      return state;
  }
}
